import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Moment from 'moment';
import ReactDOM from 'react-dom';
import I18n from 'i18n-react';
import BirthDateInfoModal from '../birthDateInfoModal/BirthDateInfoModal';
import './AgeField.css';


const DATE_FORMAT = 'DD/MM/YYYY';
const MIN_DATE = '01/01/1900';
const ADULT = 'ADT';
const CHILD = 'CH';
const INFANT = 'IN';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  passengerType: PropTypes.oneOf([ADULT, CHILD, INFANT]).isRequired,
  lastFlightDate: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  isFieldsEnabled: PropTypes.bool,
  isRenderIconEdit: PropTypes.bool,
  isEditing: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool,
  isPassengerComarch: PropTypes.bool
};

const defaultProps = {
  label: '',
  required: false,
  errorMessage: '',
  placeholder: '',
  value: null,
};

class AgeField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      value: props.value ? props.value : '',
      errorMessage: '',
      showModal: false,
      isEditing: props.isEditing || false,
      isCallcenterEnabled: props.isCallcenterEnabled || false,
    };
  }

  componentWillReceiveProps(props) {
    if (props.value !== null) {
      this.setState({
        value: props.value
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFieldsEnabled !== this.props.isFieldsEnabled) {
      this.setState({ isEditing: this.props.isFieldsEnabled });
    }
  }

  changeModalState = () => {
    if (this.state.showModal === true) {
      return this.setState({
        showModal: false
      });
    } else {
      this.setState({
        showModal: true
      });
    }
  };

  handleEditClick = () => {
    this.setState({ isEditing: true });
  };

  handleChange = event => {
    const value = event.target.value;
    this.setState({ value }, () => {
      const dateValue = Moment(value, DATE_FORMAT);
      if (this.verifyAge(dateValue)) {
        this.setState({
          showModal: true
        });
      }
    });
  };

  verifyAge = dateValue => {
    const ageLimit = Moment()
      .subtract(100, 'years')
      .subtract(1, 'days');
    return dateValue.isBefore(ageLimit);
  };

  renderIconEdit() {
    const dateValue = Moment(this.state.value, DATE_FORMAT);
    if (this.props.isRenderIconEdit && !this.state.isEditing && this.verifyAge(dateValue)) {
      return (
        <Button type="button" className="icon-button" onClick={this.handleEditClick}>
          <svg className="icon" viewBox="0 0 1024 1024" width="20" height="20">
            <path
              transform="scale(1, -1) translate(0, -1024)"
              d="M884 638.667l-78-78-160 160 78 78q12 12 30 12t30-12l100-100q12-12 12-30t-12-30zM128 202.667l472 472 160-160-472-472h-160v160z"
            />
          </svg>
        </Button>
      );
    }
  }

  renderBirthDateInfoModal() {
      return (
        <BirthDateInfoModal
          onClose={() => this.changeModalState()}
          showModal={this.state.showModal === true}
          isCallcenterEnabled={this.state.isCallcenterEnabled}
          isPassengerComarch={this.props.isPassengerComarch}
        />
      );
    }
    
  renderLabel() {
    let label = '';

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_ageFieldLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }

  renderField() {
    return (
      <div className="form-group">
        <Row>
          <Col xs={12}>
            <div className="input-with-icon">
              <input
                id={`${this.props.id}_ageFieldId`}
                onBlur={event => this.validateField(event.target.value) && this.handleChange(event)}
                onChange={event => this.removeInvalidCharacters(event.target.value)}
                placeholder={I18n.translate(this.props.placeholder)}
                maxLength="10"
                className={`data-hj-whitelist Field__input ${
                  this.state.isValidState ? 'Field__validInput' : 'Field__invalidInput'
                }`}
                value={this.state.value}
                ref={c => (this.input = c)}
                disabled={!this.state.isEditing && this.props.isRenderIconEdit}
              />
              {this.renderIconEdit()}
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}_ageFieldFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_ageFieldFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(this.state.errorMessage)}</span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  validateField = value => {
    const dateValue = Moment(value, DATE_FORMAT);

    let errorMessage = '';

    const datePlus2 = dateValue.clone().add(2, 'y');
    const datePlus12 = dateValue.clone().add(12, 'y');
    const lastFlightDate = Moment(this.props.lastFlightDate, DATE_FORMAT);

    if (this.props.required && !dateValue.isValid()) {
      errorMessage = this.props.errorMessage;
    } else if (value.length === 8) {
      errorMessage = 'components.passengerInfo.birthdate.minplaceholder';
    } else if (dateValue.isBefore(Moment(MIN_DATE, DATE_FORMAT))) {
      errorMessage = 'components.passengerInfo.birthdate.minAgeErrorMessage';
    } else if (this.props.passengerType === ADULT && lastFlightDate.isSameOrBefore(datePlus12)) {
      errorMessage = 'components.passengerInfo.birthdate.adultErrorMessage';
    } else if (
      this.props.passengerType === CHILD &&
      (lastFlightDate.isSameOrBefore(datePlus2) || lastFlightDate.isAfter(datePlus12))
    ) {
      errorMessage = 'components.passengerInfo.birthdate.childErrorMessage';
    } else if (this.props.passengerType === INFANT && lastFlightDate.isAfter(datePlus2)) {
      errorMessage = 'components.passengerInfo.birthdate.infantErrorMessage';
    }

    const isValid = !errorMessage;
    this.setState({
      isValidState: isValid,
      value: dateValue.isValid() ? value : '',
      errorMessage: errorMessage
    });

    this.props.changeValue(dateValue.isValid() ? value : '');
    return isValid;
  };

  removeInvalidCharacters = value => {
    for (var newValue = '', i = 0; i < value.length; i++) {
      if (value.charAt(i).match(/[0-9\\/]/)) {
        newValue += newValue.length === 2 || newValue.length === 5 ? '/' : '';
        newValue += !value.charAt(i).match(/[\\/]/) ? value.substr(i, 1) : '';
      }
    }
    this.setState({
      value: newValue
    });

    // Fix bug cursor Android
    const component = ReactDOM.findDOMNode(this.input);
    setImmediate(() => {
      component.setSelectionRange(component.value.length, component.value.length);
    });
  };

  render() {
    return (
      <div id={this.props.id} className="AgeField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
        {this.renderBirthDateInfoModal()}
      </div>
    );
  }
}

AgeField.propTypes = propTypes;
AgeField.defaultProps = defaultProps;

export default AgeField;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/ageField/AgeField.jsx